<template>
    <input-select
        id="customerIdentification_input"
        v-model="selected"
        aria-describedby="customerIdentification_error"
        :aria-invalid="error ? 'true' : 'false'"
        name="customerIdentification"
        :loading="loading"
        :items="options"
    />
</template>

<script>
import InputSelect from "@/components/inputs/InputSelect";

import { mapGetters, mapMutations } from "vuex";

export default {
    components: {
        InputSelect
    },
    props: {
        error: {
            type: String,
            default: null,
            required: false
        }
    },
    computed: {
        selected: {
            get() {
                const identificationType = this.$store.getters[
                    "customer/getIdentificationType"
                ];
                if (identificationType) {
                    return identificationType.id;
                } else {
                    return null;
                }
            },
            set(value) {
                this.updateCustomer({
                    identificationType:
                        value === null
                            ? null
                            : this.convertToIdentificationType(value)
                });
            }
        },
        loading() {
            return this.availableTypes.length === 0;
        },
        options() {
            return this.availableTypes.map(this.convertToOption);
        },
        ...mapGetters({
            availableTypes: "identification/getIdentificationTypes"
        })
    },
    methods: {
        convertToIdentificationType(value) {
            return this.availableTypes.filter(item => {
                return item.id === value;
            })[0];
        },
        convertToOption(type) {
            return (
                type && {
                    value: type.id,
                    title: type.texts[this.$i18n.locale] || type.texts.en
                }
            );
        },
        ...mapMutations({
            updateCustomer: "customer/updateCustomer"
        })
    }
};
</script>
